import React from "react";

class VesselFinderMap extends React.Component {
  createVesselFinderUrl(params) {
    return (
      "https://www.vesselfinder.com/aismap?" +
      "zoom=" +
      (params.zoom === undefined ? "undefined" : params.zoom) +
      (params.latitude === undefined
        ? "&lat=undefined"
        : "&lat=" + params.latitude) +
      (params.longitude === undefined
        ? "&lon=undefined"
        : "&lon=" + params.longitude) +
      "&width=" +
      params.width +
      "&height=" +
      params.height +
      "&names=" +
      params.names +
      (params.mmsi === undefined ? "" : "&mmsi=" + params.mmsi) +
      (params.imo === undefined ? "" : "&imo=" + params.imo) +
      "&track=" +
      params.showTrack +
      // + ((params.fleet === undefined) ? '&fleet=false' : '&fleet='+params.fleet)
      // + ((params.fleetName === undefined) ? '&fleet_name=false' : '&fleet_name='+params.fleetName)
      // + ((params.fleetTimespan !== undefined) ? '&fleet_timespan=' + params.fleetTimespan : '')
      // + ((params.fleetHideOldPositions === undefined) ? '&fleet_hide_old_positions=false' : '&fleet_hide_old_positions='+params.fleetHideOldPositions)
      "&clicktoact=" +
      params.clickToActivate +
      "&store_pos=" +
      params.storePosition +
      (params.fil === undefined ? "" : "&fil=" + params.fil) +
      (params.defaultMaptype === undefined
        ? ""
        : "&default_maptype=" + params.defaultMaptype) +
      "&ra=" +
      encodeURIComponent(window.location.href)
    );
  }

  render() {
    return (
      <div>
        <iframe
          name="vesselfinder"
          title="VesselFinder"
          id="vesselfinder"
          width={this.props.params.width}
          height={this.props.params.height}
          frameBorder="0"
          src={this.createVesselFinderUrl(this.props.params)}
        >
          Browser does not support embedded objects.
          <br />
          Visit directly{" "}
          <a
            href="https://www.vesselfinder.com"
            rel="noreferrer"
            target="_blank"
          >
            www.vesselfinder.com
          </a>
        </iframe>
      </div>
    );
  }
}

export default VesselFinderMap;
